// Simple state manager for BuddyPress UI (key/value store + pub/sub)
const _store = Object.create(null);
const _listeners = new Map();

function get(key) {
    return _store[key];
}

function set(key, value) {
    const prev = _store[key];
    _store[key] = value;
    const list = _listeners.get(key);
    if (list && list.length) {
        list.forEach((fn) => {
            try {
                fn(value, prev);
            } catch (err) {
                // swallow listener errors to avoid breaking app flow
                console.error('bp.state listener error', err);
            }
        });
    }
    return value;
}

function subscribe(key, fn) {
    if (!_listeners.has(key)) _listeners.set(key, []);
    _listeners.get(key).push(fn);
    return () => unsubscribe(key, fn);
}

function unsubscribe(key, fn) {
    if (!_listeners.has(key)) return;
    const filtered = _listeners.get(key).filter((f) => f !== fn);
    if (filtered.length) _listeners.set(key, filtered);
    else _listeners.delete(key);
}

function clear() {
    Object.keys(_store).forEach((k) => delete _store[k]);
    _listeners.clear();
}

export { get, set, subscribe, unsubscribe, clear };

export default {
    get,
    set,
    subscribe,
    unsubscribe,
    clear,
};
